export default __webpack_public_path__ + "static/amara-20cd419e7ea4af7074c5de1a6126ab7f.png";